// extracted by mini-css-extract-plugin
export default {"timeline__group__body":"styles_timeline__group__body__D1Sa2"};